import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const StyledSubmitButton = styled(IconButton)`
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
    flex-shrink: 0;
    position: absolute;
    right: -6px;
    top: -6px;

    & ${SWReactIcons} {
        height: auto;

        & svg path {
            fill: ${({ isDisabled }) => (isDisabled ? colorsPalettes.carbon["200"] : colorsPalettes.blue["400"])};
        }
    }

    &:hover ${SWReactIcons} {
        & svg path {
            fill: ${({ isDisabled }) => (isDisabled ? colorsPalettes.carbon["200"] : colorsPalettes.blue["400"])};
        }
    }
`;

export const StyledInput = styled.input``;

export const StyledInputContainer = styled.div`
    display: flex;
    padding-right: 30px;
    position: relative;

    & > ${StyledInput} {
        background-color: transparent;
        border: none;
        border-bottom: 1px solid ${colorsPalettes.blue["400"]};
        box-shadow: none;
        display: block;
        flex-grow: 1;
        line-height: 20px;
        margin: 0;
        min-width: 20px;
        outline: none;
        padding: 0;
        width: auto;
        ${mixins.setFont({
            $color: colorsPalettes.carbon["400"],
            $weight: 500,
            $size: 16,
        })};

        &::selection {
            background-color: ${colorsPalettes.blue["100"]};
        }
    }
`;

export const StyledText = styled.span`
    ${mixins.setFont({
        $color: colorsPalettes.carbon["400"],
        $weight: 400,
        $size: 14,
    })};
    ${mixins.truncateText()};
    user-select: none;
    line-height: 20px;
`;
